import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { AppleCareModalService } from '@core';

export interface AppleCareModalConfig {
  product: any;
  isOpen?: boolean;
  showCloseButton?: boolean;
  allowBackdropClose?: boolean;
}

@Component({
  selector: 'app-applecare-modal',
  templateUrl: './applecare-modal.component.html',
  styleUrls: ['./applecare-modal.component.scss'],
})
export class ApplecareModalComponent {
  @Input() isOpen = false;
  @Input() product: any;
  @Input() showCloseButton = true;
  @Input() allowBackdropClose = true;
  @Input() config: AppleCareModalConfig | undefined;
  @Output() closeModal = new EventEmitter<void>();
  @Output() productAction = new EventEmitter<any>();

  @ViewChild('videoPlayer') videoPlayer?: ElementRef<HTMLVideoElement>;

  currentProduct: any = null;
  showVideo = false;
  hasVideo = true;

  // Simple video URLs - replace with your actual URLs
  private videoUrls = {
    iphone: 'https://maxsite.b-cdn.net/Chase/Apple/AppleCare/ACplus PDP_iPhone_US-EN_Option 01_Hero_002.mp4',
    ipad: 'https://maxsite.b-cdn.net/Chase/Apple/AppleCare/ACplus PDP iPad_US-EN_option 01_Hero_v1.mp4',
    macbook: 'https://maxsite.b-cdn.net/Chase/Apple/AppleCare/ACplus PDP Mac_US-EN_option 01_v1.mp4',
    watch: 'https://maxsite.b-cdn.net/Chase/Apple/AppleCare/ACplus PDP AppleWatch_US-EN_option 01_Hero_v1.mp4',
    airpods: 'https://maxsite.b-cdn.net/Chase/Apple/AppleCare/ACplus PDP_AirPods_US-EN_Option 01_Hero_001.mp4',
    default: 'https://maxsite.b-cdn.net/Chase/Apple/AppleCare/ACplus PDP Mac_US-EN_option 01_v1.mp4',
  };

  constructor(private modalService: AppleCareModalService) {}

  ngOnInit() {
    this.modalService.modalData$.subscribe((data) => {
      this.currentProduct = data;
    });

    this.modalService.isModalOpen$.subscribe((isOpen) => {
      this.isOpen = isOpen;
    });
  }
  get shouldShowModal(): boolean {
    return this.isOpen && this.currentProduct;
  }

  onClose() {
    this.showVideo = false;
    this.modalService.closeModal();
  }

  onBackdropClick(event: Event) {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  getVideoUrl(): string {
    if (!this.currentProduct) return this.videoUrls.default;

    // First try the explicit category field
    let category = this.currentProduct.category;

    // If no category is present, try to infer it from the id or title
    if (!category && this.currentProduct.id) {
      const id = this.currentProduct.id.toLowerCase();

      if (id.includes('ipad')) category = 'ipad';
      else if (id.includes('iphone')) category = 'iphone';
      else if (id.includes('macbook')) category = 'macbook';
      else if (id.includes('watch')) category = 'watch';
      else if (id.includes('airpods')) category = 'airpods';
      else if (id.includes('applecare')) category = 'applecare';
      else category = 'default';
    }

    // Fallback to default
    return this.videoUrls[category] || this.videoUrls.default;
  }

  getVideoPoster(): string {
    return this.currentProduct?.image?.src || '';
  }
}
